module.exports = __webpack_public_path__ + "static/top-ed58ae1e7b55962e1267229690329cc5.png";